import { formatToCurrencyType } from "helper/common";
import React from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
const {
  INPUT,
  DATE,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  DATE_ON,
  NUMBER,
  CHECKBOX,
  RADIO,
  NORMAL_CHECKBOX,
} = FIELD_TYPE;

const cssProps = {
  labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
  wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  css: { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 },
};

const cssProps2 = {
  labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
  wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
};

const cssProps3 = {
  labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
  wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 20 },
  css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
};

const searchFields = [
  {
    name: "tenGoiDichVu",
    label: "Tên gói",
    type: INPUT,
    allowClear: true,
    ...cssProps3,
  },
];
const packageColums: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (value, record, index) => index + 1,
    align: "center",
  },
  { title: "Mã", dataIndex: "id", show: true, align: "left" },
  {
    title: "Tên gói DV",
    dataIndex: "tenGoiDichVu",
    show: true,
    align: "left",
  },
  {
    title: "Giá BV",
    dataIndex: "giaBv",
    show: true,
    align: "left",
    render: (v, r, i) => formatToCurrencyType(v),
  },
  {
    title: "Giá BHYT",
    dataIndex: "giaBH",
    show: true,
    align: "left",
    render: (v, r, i) => formatToCurrencyType(v),
  },
  {
    title: "Mô tả",
    dataIndex: "moTa",
    show: true,
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    show: true,
    align: "left",
  },
  {
    title: "Thao tác",
    dataIndex: "actions",
    key: "actions",
    width: "50",
  },
];

const detailServiceFields = [
  {
    name: "tenGoiDichVu",
    label: "Tên dịch vụ",
    type: INPUT,
    allowClear: true,
    ...cssProps3,
    rules: [{ required: true, message: "Tên dịch vụ là bắt buộc!" }],
  },
  {
    name: "giaBv",
    label: "Giá BV",
    type: CURRENCY,
    allowClear: true,
    ...cssProps2,
  },
  {
    name: "mucBVGiam",
    label: "Mức BV Giảm",
    type: CURRENCY,
    allowClear: true,
    ...cssProps2,
  },
  {
    name: "mucBH",
    label: "Mức BH",
    type: NUMBER,
    suffix: "%",
    ...cssProps2,
  },
  {
    name: "giaBH",
    label: "Giá BH",
    type: CURRENCY,
    allowClear: true,
    ...cssProps2,
  },
  {
    name: "nbChiTra",
    label: "NB đồng chi trả",
    type: CURRENCY,
    allowClear: true,
    ...cssProps2,
  },
  {
    name: "nbTuTra",
    label: "NB tự trả",
    type: CURRENCY,
    allowClear: true,
    ...cssProps2,
  },
  {
    name: "tongNbTra",
    label: "Tổng NB trả",
    type: CURRENCY,
    allowClear: true,
    ...cssProps2,
  },
  {
    name: "trangThai",
    label: "Trạng thái",
    type: SELECT,
    allowClear: true,
    options: [
      {
        label: "Hiệu lực",
        value: 0,
      },
      {
        label: "Hết hạn hiệu lực",
        value: 1,
      },
    ],
    ...cssProps2,
  },
];

const detailPackageColums: ColumnsEdit = [
  { title: "Nhóm", dataIndex: "nhom", show: true, align: "left" },
  {
    title: "Tên thành phần",
    dataIndex: "tenThanhPhan",
    show: true,
    align: "left",
  },
  { title: "Giá BV", dataIndex: "giaBv", show: true, align: "right" },
  { title: "Giá BHYT", dataIndex: "giaBHYT", show: true, align: "right" },
  { title: "Ghi chú", dataIndex: "ghiChu", show: true, align: "left" },
  { title: "", dataIndex: "action", show: true, align: "center" },
];

export {
  searchFields,
  packageColums,
  detailServiceFields,
  detailPackageColums,
};
